enum SearchType {
  Voice = 'voice',
  Text = 'text',
}

export default SearchType;
